import {createContext} from 'react';

const listaParticipantesContext = createContext();

export default listaParticipantesContext;